module.exports = __webpack_public_path__ + "img/folder-shared-alt.b5a06761.svg";